@if (isInitializing) {
  <app-splashscreen></app-splashscreen>
}

@if (!isInitializing) {
<div class="flex flex-col min-h-screen">
  <p-toast position="top-right"></p-toast>
  <p-confirmDialog #noCompanyDialog appendTo="body"></p-confirmDialog>

  <!-- Header -->
  <eko-layout-header
    [logoSrc]="'assets/ui/img/logo.png'"
    [logoMobileSrc]="'assets/ui/img/logo-sygnet.png'"
    [logoAlt]="'Ekowitryna ESG'"
    [title]="pageTitle"
    [sidebarCollapsed]="sidebarCollapsed"
    [keycloakUrl]="keycloakUrl"
    [keycloakRealm]="keycloakRealm"
    [keycloakClientId]="keycloakClientId"
    (sidebarToggle)="onSidebarToggle()">
    <div slot="header-right" class="flex items-center gap-4">
      <eko-language-selector
        [currentLanguage]="currentLanguage"
        [availableLanguages]="availableLanguages"
        (languageChange)="onLanguageChange($event)">
      </eko-language-selector>
      <eko-dark-mode-toggle></eko-dark-mode-toggle>
      @if (currentUser) {
        <eko-user-profile
          [user]="currentUser"
          [authenticated]="true"
          [menuItems]="userMenuItems"
          (profileAction)="onProfileAction($event)"
          (menuItemClick)="onProfileMenuClick($event)">
        </eko-user-profile>
      }
      @if (!currentUser) {
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 bg-gray-300 dark:bg-gray-600 rounded-full animate-pulse"></div>
          <div class="flex flex-col gap-1">
            <div class="w-20 h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
            <div class="w-32 h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
          </div>
        </div>
      }
    </div>

    <!-- Wybór podmiotu dla mobile drawer -->
    <div slot="sidebar-top" class="p-4 bg-primary-100 dark:bg-primary-900 border-b border-primary-200 dark:border-primary-800">
      <app-company-select></app-company-select>
    </div>

    <div slot="sidebar-nav">
      <eko-navigation-menu
        [items]="navigationItems"
        [currentRoute]="currentRoute"
        [expandAllByDefault]="true"
        (itemClick)="onMenuClick($event)"
        (menuClosed)="onMenuClosed()">
      </eko-navigation-menu>
    </div>
  </eko-layout-header>

  <div class="flex flex-1 lg:mt-14">
    <!-- Sidebar -->
    <eko-layout-sidebar
      class="flex flex-col min-h-full"
      [collapsed]="sidebarCollapsed">
      <!-- Wybór podmiotu NAD menu -->
      <div slot="sidebar-top" class="p-4 bg-primary-100 dark:bg-primary-900 border-b border-primary-200 dark:border-primary-800">
        <app-company-select></app-company-select>
      </div>

      <!-- Menu nawigacyjne -->
      <div slot="sidebar-nav" class="flex-1 mt-4">
        <eko-navigation-menu
          [items]="navigationItems"
          [currentRoute]="currentRoute"
          [expandAllByDefault]="true"
          (itemClick)="onMenuClick($event)"
          (menuClosed)="onMenuClosed()">
        </eko-navigation-menu>
      </div>
    </eko-layout-sidebar>

    <!-- Main content -->
    <main class="flex-1 p-1 md:p-4 max-w-full overflow-x-hidden">
      <div class="grid grid-cols-1">
        <router-outlet></router-outlet>
      </div>

      <!-- Scroll to top button -->
      @if (scrolled) {
        <p-button
          pRipple
          icon="pi pi-arrow-up"
          class="fixed bottom-4 justify-center right-4 z-50 w-10 h-10 rounded-full border border-gray-200 dark:border-slate-700 bg-white shadow-lg hover:bg-slate-500 dark:bg-gray-800 dark:hover:bg-gray-900 text-slate-600 hover:text-white dark:hover:text-slate-400 cursor-pointer transition-width duration-500 ease-in-out"
          (onClick)="scrollToTop()">
        </p-button>
      }
    </main>
  </div>

  <!-- Footer -->
  <eko-layout-footer
    [appVersion]="appVersion"
    [logoSrc]="'assets/ui/img/logo.png'"
    [logoAlt]="'Ekowitryna ESG'">
    <div class="text-center">
      &copy; 2023-2025 BDO Sp. z o.o. Wszelkie prawa zastrzeżone.
    </div>
  </eko-layout-footer>
</div>
}

<footer class="hidden print:block print-footer">
  <div class="flex gap-2 items-center justify-center">
    <img class="h-8 w-8" src="assets/ui/img/logo-sygnet.png" alt="Ekowitryna">
    <span>Raport wygenerowany przy użyciu Platformy ESG ekowitryna.pl</span>
  </div>
</footer>
